"use client";

import { Grid2, Typography } from "@repo/ui";
import { CheckCircleIcon } from "@spoctech/icons";
import Section from "../components/Section";
import WebinarRegistrationForm from "@/components/forms/WebinarRegistrationForm";

type BenefitOnlineClassProps = {
  sectionInfo: PageSections;
  data: {
    heading: string;
    description?: string;
    imageAltText?: string;
    imagePath?: string;
    lists?: { text: string }[];
    benefitOnlineClass: {
      eventId: number;
      serviceId: number;
    };
  };
};

const BenefitOnlineClass = ({ sectionInfo, data }: BenefitOnlineClassProps) => {
  return (
    <Section id={sectionInfo.id} className={sectionInfo.sectionClass}>
      <Grid2 container columnSpacing={4} align="center" className="relative">
        <Grid2 size={{ sm: 12, md: 7, lg: 7 }}>
          <div className="md:pb-16">
            <Typography variant="h2" gutterBottom>
              {data?.heading}
            </Typography>
            <Typography paragraph>{data?.description}</Typography>
            <ul>
              {data?.lists?.map((item) => (
                <li className="flex gap-2 items-center pb-2" key={item.text}>
                  <CheckCircleIcon className="!text-success-main flex-shrink-0" />{" "}
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        </Grid2>
        <Grid2 size={{ sm: 12, md: 5, lg: 5 }}>
          <WebinarRegistrationForm
            serviceId={data?.benefitOnlineClass?.serviceId}
            eventId={data?.benefitOnlineClass?.eventId}
          />
        </Grid2>
      </Grid2>
    </Section>
  );
};

export default BenefitOnlineClass;
